// Shared Dynamic Background System - Extracted for Reusability

// Dynamic Background System Variables
let backgroundInitialized = false;
let lastPlayedAlbum = null;
let backgroundTimeout = null;
let starsCreated = false;
const BACKGROUND_TIMEOUT = 180000; // 3 minutes

// Album-to-CSS class mapping for cosmic nebula background colors
const albumBackgroundClasses = {
    "Ronald Jenkees": "rj-bg-ronald-jenkees",      // Brown/beige/white palette
    "Disorganized Fun": "rj-bg-disorganized-fun", // Blue-gray/teal/sage palette
    "Days Away": "rj-bg-days-away",               // Purple/blue/green/gold palette  
    "Alpha Numeric": "rj-bg-alpha-numeric",       // Green/blue-gray/light blue palette
    "Make It Fun Vol. 1": "rj-bg-make-it-fun-v1",     // Dark brown/cream/purple/gold palette
    "Rhodes Deep": "rj-bg-rhodes-deep"            // Purple/orange/pink palette
};

// Dynamic Background System Functions
function rjInitializeDynamicBackground() {
    if (backgroundInitialized) {
        return;
    }
    
    const backgroundContainer = document.getElementById('rj-dynamic-bg');
    const starsContainer = document.getElementById('rj-stars-container');
    
    if (!backgroundContainer || !starsContainer) {
        console.error('Background containers not found');
        return;
    }
    
    rjCreateStars();
    rjScheduleShootingStars();
    
    backgroundInitialized = true;
}

function rjCreateStars() {
    starsCreated = true;
}

function rjScheduleShootingStars() {
    // Create initial shooting star after a delay
    setTimeout(rjCreateShootingStar, 8000 + Math.random() * 5000);
    
    // Schedule periodic shooting stars
    setInterval(() => {
        rjCreateShootingStar();
    }, 20000 + Math.random() * 15000);
}

function rjCreateShootingStar() {
    const starsContainer = document.getElementById('rj-stars-container');
    if (!starsContainer) return;
    
    const shootingStar = document.createElement('div');
    shootingStar.className = 'rj-shooting-star';
    
    // Random starting position (top area)
    shootingStar.style.left = Math.random() * 50 + '%';
    shootingStar.style.top = Math.random() * 30 + '%';
    
    starsContainer.appendChild(shootingStar);
    
    // Remove after animation completes
    setTimeout(() => {
        if (shootingStar.parentNode === starsContainer) {
            starsContainer.removeChild(shootingStar);
        }
    }, 12000);
}

function rjTransitionToAlbumBackground(albumName) {
    if (!albumName || !albumBackgroundClasses[albumName]) {
        return;
    }
    
    lastPlayedAlbum = albumName;
    
    const body = document.body;
    if (!body) {
        console.error('Body element not found');
        return;
    }
    
    Object.values(albumBackgroundClasses).forEach(className => {
        body.classList.remove(className);
    });
    
    const albumClass = albumBackgroundClasses[albumName];
    body.classList.add(albumClass);
    
    if (backgroundTimeout) {
        clearTimeout(backgroundTimeout);
    }
    
    backgroundTimeout = setTimeout(() => {
        rjReturnToNeutralBackground();
    }, BACKGROUND_TIMEOUT);
}

function rjReturnToNeutralBackground() {
    const body = document.body;
    if (!body) return;
    
    Object.values(albumBackgroundClasses).forEach(className => {
        body.classList.remove(className);
    });
    
    lastPlayedAlbum = null;
    backgroundTimeout = null;
}

// Auto-initialize background system when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    // Only initialize if background containers exist
    if (document.getElementById('rj-dynamic-bg') && document.getElementById('rj-stars-container')) {
        setTimeout(() => {
            rjInitializeDynamicBackground();
        }, 200);
    }
});

// Export functions for external use (if needed)
if (typeof window !== 'undefined') {
    window.rjSharedBackground = {
        initialize: rjInitializeDynamicBackground,
        transitionToAlbum: rjTransitionToAlbumBackground,
        returnToNeutral: rjReturnToNeutralBackground,
        albumClasses: albumBackgroundClasses
    };
}
